import { BaseUrlService } from './base-url.service';
import { storageBaseUrl } from './../app.constants';

export class PreviewService {
  static $inject: string[] = ['$http', 'BaseUrlService'];

  private baseUrl: any;

  constructor(
    private $http: ng.IHttpService,
    private _baseUrlService: BaseUrlService,
  ) {
    this.baseUrl = _baseUrlService.getBaseUrl();
  }

  getPath(path: any, type: any) {
    return this.$http.get(this.baseUrl + '/preview/' + encodeURIComponent(path) + '/' + encodeURIComponent(type)); // ,  {responseType: 'arraybuffer'}
  }

  getStoragePath(path: any) {
    return storageBaseUrl + path;
  }

  showPreview(item: any, showModalPreview: any) {
    let showModal = false;
    let type = 'pdf';

    if (item.content_type !== undefined) {
      if (item.content_type === 'application/pdf' || item.content_type.indexOf('image/') !== -1) {
        type = item.content_type === 'application/pdf' ? 'pdf' : 'img';
        showModal = true;
      }
    } else {
      if (item.fileName !== undefined || item.filePathPDF !== undefined || item.file_path_pdf) {
        var extension = item.fileName !== undefined ?
          item.fileName.split('.').pop()
          : (item.filePathPDF !== undefined) ? item.filePathPDF.split('.').pop() : item.file_path_pdf.split('.').pop();
        if (extension === 'pdf' || extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'xml') {
          type = extension === 'pdf' ? 'pdf' : extension === 'xml' ? 'xml' : 'img';
          showModal = true;
        }
      }
    }

    if (showModal) {
      showModalPreview(item, type);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/preview.service.ts